// @flow

import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import AstrntLogo from '../../styles/img/astro-logo.svg?v=1'

const HeaderClean = () => {
  return (
    <header className="clear">
      <section>
        <Link to="/" className="logo">
          <img src={AstrntLogo} />
        </Link>
      </section>
    </header>
  )
}

export default HeaderClean